import { Tooltip as TooltipBase } from "@rentiohq/web-shared/dist/components";
import styled, { iconSize, spacing } from "@rentiohq/web-theme";
import { EStatus } from "./AdministrationItems.types";

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: ${spacing("loose")};
`;

export const Label = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.neutral60};
`;

export const Circle = styled.div<{ status: EStatus }>`
  width: ${iconSize("large")};
  height: ${iconSize("large")};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 2px solid
    ${props => {
      switch (props.status) {
        case EStatus.Success:
          return props.theme.getColor("green", "800");

        case EStatus.Warning:
          return props.theme.getColor("yellow", "800");

        case EStatus.Error:
          return props.theme.getColor("red", "800");

        case EStatus.None:
        default:
          return props.theme.colors.neutral30;
      }
    }};
  background: ${({ theme }) => theme.colors.neutral10};
  border-radius: 50%;
`;

// export const ChecklistProgressWrap = styled.div`
//   min-width: 200px;
//   display: flex;
//   align-items: center;
//   gap: 12px;
// `;

export const CirclesAndButtonRow = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
`;

export const Tooltip = styled(TooltipBase).attrs<{ status: EStatus }>(
  props => ({
    tooltipContentStyle: {
      backgroundColor: (() => {
        switch (props.status) {
          case EStatus.Success:
            return props.theme.getColor("green", "800");

          case EStatus.Warning:
            return props.theme.getColor("yellow", "800");

          case EStatus.Error:
            return props.theme.getColor("red", "800");

          case EStatus.None:
            return props.theme.colors.neutral30;

          default:
            return "inherit";
        }
      })(),
    },
  }),
)<{ status: EStatus }>``;

export const EntryItemsWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: ${spacing("loose")};
  flex-wrap: wrap;
`;
